import React from 'react';

import {
  StyledDesktopContainer,
  StyledImageWrapper,
  StyledImage,
  StyledTextWrapper,
  StyledText,
} from './styles';

import type { IHeaderBannerDesktop } from '../types';
import { HEADER_BANNER_DESKTOP_DATA_TEST_ID } from '../constants';

export const DesktopHeaderBanner = (
  props: IHeaderBannerDesktop,
): JSX.Element => {
  const { desktopText, imageSrc } = props;

  return (
    <StyledDesktopContainer data-testid={HEADER_BANNER_DESKTOP_DATA_TEST_ID}>
      {!!imageSrc && (
        <StyledImageWrapper $isMobile={false}>
          <StyledImage
            src={imageSrc.webp_x30x30}
            fallback={imageSrc.x30x30}
            $isMobile={false}
          />
        </StyledImageWrapper>
      )}
      <StyledTextWrapper $isMobile={false}>
        <StyledText $isMobile={false} $isHeading>
          {desktopText}
        </StyledText>
      </StyledTextWrapper>
    </StyledDesktopContainer>
  );
};
